// import React from 'react';
// import classes from '../HospitalList/HospitalList.module.scss';

// const HospitalDetails = ({ details }) => {
//   if (!details || typeof details !== 'object') return null;

//   return (
//     <div className={classes.HospitalDetails}>
//       <h3>Hospital Details</h3>
//       <div className={classes.DetailCard}>
//         {Object.entries(details).map(([key, value]) => (
//           <div key={key} className={classes.DetailRow}>
//             <strong>{key.replace(/_/g, ' ')}:</strong>{' '}
//             <span>
//               {
//                 typeof value === 'object' && value !== null
//                   ? JSON.stringify(value)
//                   : value || 'N/A'
//               }
//             </span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default HospitalDetails;



/////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////This code look like into the card format of the Hospitals Details:::::::::::::
/////////////////////////////////////////////////////////////////////////////////////////


import React from 'react';
import classes from '../HospitalList/HospitalList.module.scss';

const HospitalDetails = ({ details }) => {
  if (!details || typeof details !== 'object') return null;
  return (
    <div className={classes.HospitalDetails}>
      <h3 className={classes.sectionHeading}>Hospital Details</h3>
      <div className={classes.DetailCard}>
        <div className={classes.DetailRow}>
          <div className={classes.DetailValue}>
            <div className={classes.DetailValue} style={{textAlign:"justify",textJustify: "inter-word"}}>
              {details.cata}: {details.hsptl_name}
              <br />
              <b>Address:</b> {details.hsptl_add}
              <br />
              <b>Contact:</b> {details.contact_person}, {details.desig}
              <br />
              {details.mob_no}
              <br />
              Offer: {details.offer}
              <br />
              Offer From: {details.offer_from}
              <br />
              Offer Till: {details.offer_to}
            </div>
          </div>
        </div>
        {/* {Object.entries(details).map(([key, value]) => (
          <div key={key} className={classes.DetailRow}>
            <div className={classes.DetailKey}>{key.replace(/_/g, ' ')}:</div>
            <div className={classes.DetailValue}>
              {typeof value === 'object' && value !== null
                ? JSON.stringify(value)
                : value || 'N/A'}
            </div>
          </div>
        ))} */}
      </div>
    </div>

  );
};

export default HospitalDetails;
